import { render, staticRenderFns } from "./BetgameInfo.vue?vue&type=template&id=1cfe671a&scoped=true"
import script from "./BetgameInfo.vue?vue&type=script&lang=js"
export * from "./BetgameInfo.vue?vue&type=script&lang=js"
import style0 from "./BetgameInfo.vue?vue&type=style&index=0&id=1cfe671a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfe671a",
  null
  
)

export default component.exports